import {createFileRoute} from "@tanstack/react-router";
import {getDataSourcesForFrontend} from "~/domainModels/dag/dataSources";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {throwRedirectToConfigMyDataConnectionsWhenPresent} from "~/workspaceConfig/configOttosyncRedirects";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottosync/_ottosyncScaffold/data-sources/existing",
)({
    beforeLoad: ({context}) => {
        throwRedirectToConfigMyDataConnectionsWhenPresent(context.workspace.id);
    },
    loader: async ({context}) => {
        const dataSourcesResult = await getDataSourcesForFrontend({
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            workspaceId: context.workspace.id,
        });
        if (dataSourcesResult.success !== true) {
            throw dataSourcesResult.error;
        }
        let dataSources = dataSourcesResult.data;
        dataSources = dataSources.filter((dataSource) => dataSource.dataSourceInstances.length > 0);

        const allTags = dataSources.map((d) => d.tags).flat();
        const categoryTagsSet = new Set(allTags.filter((tag) => tag.startsWith("category:")));
        const integrationTagsSet = new Set(allTags.filter((tag) => tag.startsWith("integration:")));
        const platformTagsSet = new Set(allTags.filter((tag) => tag.startsWith("source-platform:")));

        return {
            dataSources: dataSources,
            allCategoryTags: Array.from(categoryTagsSet),
            allIntegrationTags: Array.from(integrationTagsSet),
            allPlatformTags: Array.from(platformTagsSet),
            workspace: context.workspace,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            //
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
